(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aidefer-pdp-v4"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (window.__aideferPDPV8) { window.__aideferPDPV8.boot(); return; }
  const cleanText = (value) => String(value ?? '').replace(/\u00a0/g, ' ').replace(/\r/g, '').trim();

  const readBlocks = (source) => {
    const blocks = [];
    let buffer = '';
    const flush = () => {
      const text = cleanText(buffer);
      if (text) blocks.push({ type: 'text', text });
      buffer = '';
    };
    const visit = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = (node.textContent || '').split(/\n/);
        parts.forEach((part, i) => { if (i) flush(); buffer += part; });
        return;
      }
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      const tag = node.tagName.toLowerCase();
      if (['script', 'style', 'template'].includes(tag)) return;
      if (tag === 'br') { flush(); return; }
      if (/^h[1-6]$/.test(tag)) {
        flush();
        const text = cleanText(node.textContent);
        if (text) blocks.push({ type: 'heading', text });
        return;
      }
      const block = ['div', 'p', 'li', 'ul', 'ol', 'section', 'blockquote'].includes(tag);
      if (block) flush();
      node.childNodes.forEach(visit);
      if (block) flush();
    };
    source.childNodes.forEach(visit);
    flush();
    return blocks;
  };

  const hasComplexMarkup = (source) => Boolean(source.querySelector('table, a, img, video, iframe, details, dl'));
  const stripBullet = (text) => cleanText(text).replace(/^(?:[•▪◦✓]|[-–—]\s)\s*/, '');

  const splitLabelValue = (line) => {
    const text = stripBullet(line);
    const colon = text.indexOf(':');
    if (colon > 0 && colon < 100 && !/https?:\/\//i.test(text.slice(0, colon + 3))) {
      const label = cleanText(text.slice(0, colon));
      const value = cleanText(text.slice(colon + 1));
      if (value) return { label, value };
    }
    const dash = text.match(/^(.{1,80}?)\s+[–—-]\s+(.+)$/);
    if (dash) return { label: cleanText(dash[1]), value: cleanText(dash[2]) };
    return null;
  };

  const renderKeyFeatures = (section) => {
    const source = section.querySelector('[data-key-features-fallback]');
    if (!source || source.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (blocks.some((block) => block.type === 'heading' && !/^key features:?$/i.test(block.text))) return;
    const items = blocks.filter((block) => block.type === 'text').map((block) => stripBullet(block.text)).filter(Boolean);
    if (!items.length) return;
    const makeList = (rows) => {
      const list = document.createElement('ul');
      rows.forEach((item) => {
        const li = document.createElement('li');
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '✓';
        li.append(icon, document.createTextNode(item));
        list.append(li);
      });
      return list;
    };
    source.replaceChildren(makeList(items));
    source.dataset.enhanced = 'true';
  };

  const renderSpecifications = (section) => {
    const source = section.querySelector('[data-specs-fallback]');
    const target = section.querySelector('[data-specs-content]');
    if (!source || !target || target.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (!blocks.length) return;
    const groups = [];
    let group = { title: 'Product Specifications', entries: [] };
    let parsedRows = 0;
    let ambiguousHeading = false;
    const pushGroup = () => { if (group.entries.length) groups.push(group); };
    blocks.forEach((block) => {
      const text = stripBullet(block.text);
      const explicitHeading = block.type === 'heading' || /^\[.+\]$/.test(text) || /^[^:]{1,80}:$/.test(text);
      if (explicitHeading) {
        if (group.entries.length) pushGroup();
        else if (!/^(?:product )?specifications?$/i.test(group.title)) ambiguousHeading = true;
        group = { title: text.replace(/^\[|\]$/g, '').replace(/:$/, ''), entries: [] };
        return;
      }
      const row = splitLabelValue(text);
      if (row) { group.entries.push(row); parsedRows += 1; }
      else if (text) group.entries.push({ text });
    });
    if (!group.entries.length && !/^(?:product )?specifications?$/i.test(group.title)) ambiguousHeading = true;
    pushGroup();
    if (ambiguousHeading || !parsedRows || !groups.length || groups.some((item) => item.entries.some((entry) => 'text' in entry))) return;
    const fragment = document.createDocumentFragment();
    groups.forEach((item, index) => {
      const details = document.createElement('details');
      details.className = 'aidefer-pdp__spec-group';
      details.open = index === 0;
      const summary = document.createElement('summary');
      summary.textContent = item.title;
      const rows = document.createElement('dl');
      rows.className = 'aidefer-pdp__spec-rows';
      item.entries.forEach((entry) => {
        if ('text' in entry) {
          const p = document.createElement('p');
          p.className = 'aidefer-pdp__spec-note';
          p.textContent = entry.text;
          rows.append(p);
        } else {
          const row = document.createElement('div');
          row.className = 'aidefer-pdp__spec-row';
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          label.textContent = entry.label;
          value.textContent = entry.value;
          row.append(label, value);
          rows.append(row);
        }
      });
      details.append(summary, rows);
      fragment.append(details);
    });
    target.replaceChildren(fragment);
    target.dataset.enhanced = 'true';
  };

  const renderIncluded = (section) => {
    const source = section.querySelector('[data-included-fallback]');
    const target = section.querySelector('[data-included-content]');
    if (!source || !target || target.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (blocks.some((block) => block.type === 'heading')) return;
    const items = blocks.map((block) => stripBullet(block.text)).filter(Boolean);
    if (!items.length) return;
    const fragment = document.createDocumentFragment();
    items.forEach((text) => {
      const card = document.createElement('article');
      card.className = 'aidefer-pdp__included-card';
      const icon = document.createElement('div');
      icon.className = 'aidefer-pdp__included-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '◇';
      const title = document.createElement('strong');
      title.textContent = text;
      card.append(icon, title);
      fragment.append(card);
    });
    target.replaceChildren(fragment);
    target.dataset.enhanced = 'true';
  };

  const initProductContent = (section) => {
    [renderKeyFeatures, renderSpecifications, renderIncluded].forEach((enhance) => {
      try { enhance(section); }
      catch (error) { console.warn('Aidefer: original product content retained.', error); }
    });
  };

  const attachFeatureDisclosure = (section, listen, signal) => {
    const wrap = section.querySelector('[data-key-features-wrap]');
    const source = wrap?.querySelector('[data-key-features-fallback]');
    const button = wrap?.querySelector('[data-features-toggle]');
    if (!wrap || !source || !button || wrap.dataset.collapseFeatures === 'false') return () => {};
    const rows = readBlocks(source).filter((block) => block.type === 'text').map((block) => stripBullet(block.text)).filter(Boolean);
    if (!rows.length) return () => {};
    const preview = document.createElement('div');
    preview.className = 'aidefer-pdp__features-preview';
    preview.hidden = true;
    const list = document.createElement('ul');
    rows.slice(0, 3).forEach((row) => {
      const li = document.createElement('li');
      const check = document.createElement('span');
      check.textContent = '✓';
      check.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.className = 'aidefer-pdp__feature-preview-text';
      text.textContent = row;
      li.append(check, text);
      list.append(li);
    });
    preview.append(list);
    source.before(preview);
    let expanded = false;
    let needed = false;
    let frame = 0;
    let lastWidth = 0;
    const measure = () => {
      const wasHidden = source.hidden;
      const oldStyle = source.getAttribute('style');
      if (wasHidden) {
        source.style.position = 'absolute';
        source.style.visibility = 'hidden';
        source.style.width = `${wrap.clientWidth}px`;
        source.hidden = false;
      }
      const height = source.scrollHeight;
      if (wasHidden) {
        source.hidden = true;
        if (oldStyle === null) source.removeAttribute('style'); else source.setAttribute('style', oldStyle);
      }
      return height;
    };
    const apply = () => {
      source.hidden = needed && !expanded;
      preview.hidden = !needed || expanded;
      button.hidden = !needed;
      button.setAttribute('aria-expanded', String(expanded || !needed));
      button.textContent = expanded ? button.dataset.lessLabel || 'Show less' : button.dataset.moreLabel || 'Show more';
    };
    const refresh = () => {
      frame = 0;
      if (signal.aborted || !wrap.isConnected) return;
      const limit = parseFloat(getComputedStyle(wrap).getPropertyValue('--ap-features-preview')) || 84;
      needed = rows.length > 3 || measure() > limit + 2;
      if (!needed) expanded = false;
      apply();
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(refresh); };
    listen(button, 'click', () => {
      expanded = !expanded;
      apply();
      if (!expanded && button.getBoundingClientRect().top < 0) button.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
    const observer = 'ResizeObserver' in window ? new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width || 0;
      if (Math.abs(width - lastWidth) > 1) { lastWidth = width; schedule(); }
    }) : null;
    observer?.observe(wrap);
    listen(window, 'resize', schedule, { passive: true });
    document.fonts?.ready.then(() => { if (!signal.aborted) schedule(); });
    refresh();
    return () => {
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      preview.remove();
      source.hidden = false;
      button.hidden = true;
    };
  };

  const attachInteractions = (section) => {
    const controller = new AbortController();
    const { signal } = controller;
    const listen = (target, name, callback, options = {}) => target?.addEventListener(name, callback, { ...options, signal });
    const thumbs = [...section.querySelectorAll('[data-media-target]')];
    const panels = [...section.querySelectorAll('[data-media-item]')];
    const panelMap = new Map(panels.map((panel) => [panel.dataset.mediaItem, panel]));
    const status = section.querySelector('[data-gallery-status]');
    let activeId = panels.find((panel) => !panel.hidden)?.dataset.mediaItem;
    let lastZoomTrigger = null;
    let raf = 0;
    const dialog = section.querySelector('[data-zoom-dialog]');
    const zoomContent = section.querySelector('[data-zoom-content]');
    const select = section.querySelector('[data-variant-select]');
    const input = section.querySelector('[data-quantity-input]');
    const minus = section.querySelector('[data-quantity-minus]');
    const plus = section.querySelector('[data-quantity-plus]');
    const add = section.querySelector('[data-add-to-cart]');
    const sticky = section.querySelector('[data-mobile-sticky]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const cleanupFeatures = attachFeatureDisclosure(section, listen, signal);
    const picker = section.querySelector('[data-option-picker]');
    const nativeVariantField = section.querySelector('[data-native-variant-field]');
    const optionGroups = [...(picker?.querySelectorAll('[data-option-position]') || [])];
    const optionInputs = [...(picker?.querySelectorAll('[data-option-input]') || [])];
    const optionMessage = picker?.querySelector('[data-option-message]');
    let remoteRequest = null;
    let requestNumber = 0;

    const mountMedia = (panel) => {
      const template = panel.querySelector('template[data-deferred-media]');
      if (template) template.replaceWith(template.content.cloneNode(true));
      panel.querySelectorAll('iframe[data-aidefer-src]').forEach((frame) => {
        frame.src = frame.dataset.aideferSrc;
        delete frame.dataset.aideferSrc;
      });
    };
    const pauseMedia = (panel) => {
      panel.querySelectorAll('video').forEach((video) => video.pause());
      panel.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
      panel.querySelectorAll('iframe').forEach((frame) => {
        if (frame.hasAttribute('src') && frame.getAttribute('src') !== 'about:blank') {
          frame.dataset.aideferSrc = frame.getAttribute('src');
          frame.src = 'about:blank';
        }
      });
    };
    const showMedia = (id, announce = true) => {
      const key = String(id || '');
      const next = panelMap.get(key);
      if (!next) return false;
      panels.forEach((panel) => {
        const active = panel === next;
        if (!active && !panel.hidden) pauseMedia(panel);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      mountMedia(next);
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaTarget === key;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      activeId = key;
      if (announce && status) status.textContent = `Media ${panels.indexOf(next) + 1} of ${panels.length}`;
      return true;
    };
    listen(section.querySelector('[data-gallery]'), 'click', (event) => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) showMedia(thumb.dataset.mediaTarget);
      const trigger = event.target.closest('[data-zoom-open]');
      if (!trigger || !dialog?.showModal || !zoomContent) return;
      event.preventDefault();
      lastZoomTrigger = trigger;
      const image = new Image();
      image.alt = trigger.querySelector('img')?.alt || '';
      image.decoding = 'async';
      image.src = trigger.href;
      zoomContent.replaceChildren(image);
      dialog.showModal();
      dialog.querySelector('[data-zoom-close]')?.focus();
      scheduleSticky();
    });
    listen(section.querySelector('.aidefer-pdp__thumbs'), 'keydown', (event) => {
      const current = thumbs.indexOf(event.target.closest('[data-media-target]'));
      if (current < 0) return;
      let next;
      if (['ArrowRight','ArrowDown'].includes(event.key)) next = (current + 1) % thumbs.length;
      else if (['ArrowLeft','ArrowUp'].includes(event.key)) next = (current - 1 + thumbs.length) % thumbs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = thumbs.length - 1;
      else return;
      event.preventDefault();
      thumbs[next].focus({ preventScroll: true });
      thumbs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      showMedia(thumbs[next].dataset.mediaTarget);
    });
    listen(section.querySelector('[data-zoom-close]'), 'click', () => dialog?.close());
    listen(dialog, 'click', (event) => { if (event.target === dialog) dialog.close(); });
    listen(dialog, 'close', () => {
      zoomContent?.replaceChildren();
      if (lastZoomTrigger?.isConnected) lastZoomTrigger.focus({ preventScroll: true });
      scheduleSticky();
    });

    const rules = () => ({
      min: Math.max(1, Number(input?.min) || 1),
      step: Math.max(1, Number(input?.step) || 1),
      max: input?.hasAttribute('max') ? Number(input.max) : Infinity
    });
    const updateQuantityButtons = () => {
      if (!input) return;
      const { min, max, step } = rules();
      const value = Number(input.value);
      if (minus) minus.disabled = !Number.isFinite(value) || value <= min;
      if (plus) plus.disabled = !Number.isFinite(value) || value + step > max;
    };
    const normalizeQuantity = () => {
      if (!input) return;
      const { min, max, step } = rules();
      let value = Number(input.value);
      if (!Number.isFinite(value) || input.value.trim() === '') value = min;
      value = Math.max(min, value);
      value = min + Math.round((value - min) / step) * step;
      if (Number.isFinite(max)) value = Math.min(value, min + Math.floor((max - min) / step) * step);
      input.value = String(Math.max(min, value));
      updateQuantityButtons();
    };
    const changeQuantity = (direction) => {
      if (!input) return;
      normalizeQuantity();
      input.value = String(Number(input.value) + direction * rules().step);
      normalizeQuantity();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    listen(minus, 'click', () => changeQuantity(-1));
    listen(plus, 'click', () => changeQuantity(1));
    listen(input, 'input', updateQuantityButtons);
    listen(input, 'change', normalizeQuantity);

    const records = () => [...(select?.options || [])].filter((option) => option.value).map((option) => ({ option, values: optionGroups.map((group) => option.dataset[`option${group.dataset.optionPosition}`] || '') }));
    const selection = () => optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.value || '');
    const sameValues = (a, b) => a.length === b.length && a.every((value, index) => value === b[index]);
    const allVariantsLoaded = () => Number(select?.dataset.variantCount || 0) <= records().length;
    const setText = (selector, value) => { const node = section.querySelector(selector); if (node) node.textContent = value; };
    const setMessage = (message) => {
      if (optionMessage) { optionMessage.textContent = message; optionMessage.hidden = !message; }
    };
    const syncOptionLabels = () => optionGroups.forEach((group) => {
      const selected = group.querySelector('[data-option-input]:checked');
      const label = group.querySelector('[data-option-current]');
      if (label) label.textContent = selected?.value || '';
    });
    const setURL = (variantId) => {
      const url = new URL(window.location.href);
      url.searchParams.delete('option_values');
      if (variantId) url.searchParams.set('variant', variantId);
      else {
        url.searchParams.delete('variant');
        const ids = optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.dataset.optionId || '');
        if (ids.length && ids.every(Boolean)) url.searchParams.set('option_values', ids.join(','));
      }
      window.history.replaceState(window.history.state, '', url);
    };
    const paintAvailability = () => {
      syncOptionLabels();
      if (!allVariantsLoaded()) return;
      const values = selection();
      const availableRecords = records();
      optionGroups.forEach((group, index) => group.querySelectorAll('[data-option-input]').forEach((radio) => {
        const desired = [...values];
        desired[index] = radio.value;
        const match = availableRecords.find((record) => sameValues(record.values, desired));
        const state = !match ? 'missing' : match.option.dataset.available === 'true' ? 'available' : 'soldout';
        const choice = radio.closest('[data-option-choice]');
        if (choice) {
          choice.dataset.optionState = state;
          choice.title = state === 'available' ? radio.value : `${radio.value} — ${state === 'soldout' ? 'Sold out' : 'Not offered with the other selected options'}`;
        }
        radio.setAttribute('aria-label', choice?.title || radio.value);
      }));
    };
    const blockPurchase = (message, loading = false) => {
      if (select) { select.selectedIndex = -1; select.disabled = true; }
      if (add) add.disabled = true;
      setText('[data-add-label]', loading ? 'Checking options…' : 'Unavailable');
      if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = loading ? 'Checking…' : 'Unavailable'; }
      const accelerated = section.querySelector('[data-accelerated]');
      if (accelerated) accelerated.hidden = true;
      const terms = section.querySelector('.aidefer-pdp__payment-terms');
      if (terms) terms.hidden = true;
      setText('[data-current-price]', '—');
      setText('[data-sticky-price]', '—');
      for (const selector of ['[data-compare-price]', '[data-saving]', '[data-sku-wrap]']) {
        const node = section.querySelector(selector); if (node) node.hidden = true;
      }
      setText('[data-stock-status]', loading ? 'Checking availability' : 'Unavailable combination');
      section.querySelector('[data-stock-status]')?.classList.add('is-sold-out');
      setMessage(message);
      setText('[data-variant-status]', message);
      scheduleSticky();
    };
    const updateVariant = (announce = false) => {
      const option = select?.selectedOptions[0];
      if (!option || !option.value) {
        normalizeQuantity();
        if (picker && !picker.hidden) blockPurchase('This combination is not offered. Choose another option.');
        return;
      }
      select.disabled = false;
      const data = option.dataset;
      const available = data.available === 'true';
      setText('[data-current-price]', data.price || '');
      setText('[data-sticky-price]', data.price || '');
      setText('[data-compare-price]', data.compare || '');
      setText('[data-saving]', data.saving || '');
      const compare = section.querySelector('[data-compare-price]');
      const saving = section.querySelector('[data-saving]');
      if (compare) compare.hidden = !data.compare;
      if (saving) saving.hidden = !data.saving;
      const skuWrap = section.querySelector('[data-sku-wrap]');
      if (skuWrap) skuWrap.hidden = !data.sku;
      setText('[data-product-sku]', data.sku ? `SKU: ${data.sku}` : '');
      const stock = section.querySelector('[data-stock-status]');
      if (stock) {
        stock.textContent = data.stockText || (available ? 'Available' : 'Sold Out');
        stock.classList.toggle('is-sold-out', !available);
      }
      if (add) add.disabled = !available;
      setText('[data-add-label]', available ? 'Add to Cart' : 'Sold Out');
      if (stickyAdd) { stickyAdd.disabled = !available; stickyAdd.textContent = available ? 'Add to Cart' : 'Sold Out'; }
      const accelerated = section.querySelector('[data-accelerated]');
      if (accelerated) accelerated.hidden = !available;
      const terms = section.querySelector('.aidefer-pdp__payment-terms');
      if (terms) terms.hidden = false;
      if (input) {
        input.min = data.min || '1';
        input.step = data.step || '1';
        if (data.max) input.max = data.max;
        else input.removeAttribute('max');
        normalizeQuantity();
      }
      optionGroups.forEach((group) => group.querySelectorAll('[data-option-input]').forEach((radio) => {
        radio.checked = radio.value === data[`option${group.dataset.optionPosition}`];
      }));
      paintAvailability();
      setMessage(available ? '' : 'This configuration is sold out. Select another color or version.');
      if (data.mediaId) showMedia(data.mediaId, false);
      if (announce) {
        setURL(option.value);
        setText('[data-variant-status]', `${option.textContent.trim()}. ${data.price || ''}. ${stock?.textContent || ''}`);
        section.dispatchEvent(new CustomEvent('aidefer:variant-change', { bubbles: true, detail: { variantId: option.value, available } }));
      }
      scheduleSticky();
    };
    const resolveRemote = async (values) => {
      const ids = optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.dataset.optionId || '');
      if (!ids.length || ids.some((id) => !id)) { blockPurchase('Unable to check this combination. Please refresh the page.'); return; }
      remoteRequest?.abort();
      const request = new AbortController();
      remoteRequest = request;
      const sequence = ++requestNumber;
      const timeout = setTimeout(() => request.abort(), 12000);
      blockPurchase('Checking the selected options…', true);
      setURL('');
      const url = new URL(window.location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('section_id', section.dataset.sectionId);
      url.searchParams.set('option_values', ids.join(','));
      try {
        const response = await fetch(url.toString(), { credentials: 'same-origin', signal: request.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Variant lookup failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (sequence !== requestNumber || signal.aborted || !sameValues(values, selection())) return;
        const incoming = [...doc.querySelectorAll('[data-aidefer-pdp]')].find((node) => node.dataset.productId === section.dataset.productId && node.dataset.sectionId === section.dataset.sectionId);
        if (!incoming) throw new Error('Product section missing');
        incoming.querySelectorAll('[data-option-input]').forEach((next) => {
          const radio = optionInputs.find((old) => old.dataset.optionId === next.dataset.optionId);
          if (!radio) return;
          const nextChoice = next.closest('[data-option-choice]');
          if (nextChoice?.dataset.optionState) radio.closest('[data-option-choice]').dataset.optionState = nextChoice.dataset.optionState;
        });
        const incomingOption = incoming.querySelector('[data-variant-select] option[selected]');
        const incomingValues = optionGroups.map((group) => incomingOption?.dataset[`option${group.dataset.optionPosition}`] || '');
        if (!incomingOption?.value || !sameValues(incomingValues, values)) { blockPurchase('This combination is not offered. Choose another option.'); return; }
        [...select.options].filter((option) => option.value === incomingOption.value).forEach((option) => option.remove());
        const option = document.importNode(incomingOption, true);
        select.append(option);
        select.disabled = false;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (error) {
        if (sequence === requestNumber && !signal.aborted) blockPurchase('We could not check these options. Select a different option to retry, or refresh the page.');
      } finally { clearTimeout(timeout); }
    };
    const chooseOptions = (radio) => {
      const targetURL = radio.dataset.productUrl;
      if (targetURL) {
        const target = new URL(targetURL, window.location.origin);
        const current = new URL(section.dataset.productUrl || window.location.pathname, window.location.origin);
        if (target.origin === window.location.origin && target.pathname !== current.pathname) { window.location.assign(target.href); return; }
      }
      const values = selection();
      paintAvailability();
      if (!allVariantsLoaded()) { resolveRemote(values); return; }
      remoteRequest?.abort();
      requestNumber += 1;
      const match = records().find((record) => sameValues(record.values, values));
      if (!match) { blockPurchase('This combination is not offered. Choose another option.'); setURL(''); return; }
      select.disabled = false;
      select.value = match.option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    if (picker && select && optionGroups.length && optionGroups.every((group) => group.querySelector('[data-option-input]'))) {
      picker.hidden = false;
      nativeVariantField.hidden = true;
      listen(picker, 'change', (event) => { if (event.target.matches('[data-option-input]')) chooseOptions(event.target); });
  
    }
    listen(select, 'change', () => updateVariant(true));
    listen(window, 'pageshow', () => { if (!select?.disabled) updateVariant(false); });
    listen(select?.form, 'submit', (event) => {
      if (picker && !picker.hidden && (!select.value || select.disabled || add?.disabled)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setMessage('Please select an available product configuration before adding to cart.');
      }
    }, { capture: true });

    const refreshSticky = () => {
      raf = 0;
      if (!sticky || !add) return;
      const editing = document.activeElement?.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]');
      const shouldShow = mobile.matches && !editing && !dialog?.open && add.getBoundingClientRect().bottom <= 0 && section.getBoundingClientRect().bottom > window.innerHeight;
      sticky.hidden = !shouldShow;
      sticky.classList.toggle('is-visible', shouldShow);
    };
    function scheduleSticky() { if (sticky && !raf) raf = requestAnimationFrame(refreshSticky); }
    listen(stickyAdd, 'click', () => {
      normalizeQuantity();
      if (input && !input.checkValidity()) {
        input.scrollIntoView({ block: 'center' });
        input.reportValidity();
        return;
      }
      if (add && !add.disabled) add.click();
    });
    if (sticky) {
      listen(window, 'scroll', scheduleSticky, { passive: true });
      listen(window, 'resize', scheduleSticky, { passive: true });
      listen(window.visualViewport, 'resize', scheduleSticky, { passive: true });
      listen(document, 'focusin', scheduleSticky);
      listen(document, 'focusout', scheduleSticky);
    }
    if (activeId) showMedia(activeId, false);
    updateVariant(false);
    normalizeQuantity();
    scheduleSticky();
    return () => {
      controller.abort();
      requestNumber += 1;
      remoteRequest?.abort();
      cleanupFeatures();
      if (nativeVariantField) nativeVariantField.hidden = false;
      if (picker) picker.hidden = true;
      if (raf) cancelAnimationFrame(raf);
      panels.forEach(pauseMedia);
      if (dialog?.open) dialog.close();
      zoomContent?.replaceChildren();
      delete section.dataset.aideferInitialized;
    };
  };

  const instances = new Map();
  const init = (section) => {
    if (!section || instances.has(section) || section.dataset.aideferBuild !== '8') return;
    initProductContent(section);
    const cleanup = attachInteractions(section);
    instances.set(section, cleanup);
    section.dataset.aideferInitialized = '8';
  };
  const collect = (root = document) => {
    if (root.matches?.('[data-aidefer-pdp]')) init(root);
    root.querySelectorAll?.('[data-aidefer-pdp]').forEach(init);
  };
  const lifecycle = { boot: collect };
  window.__aideferPDPV8 = lifecycle;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => collect(), { once: true });
  else collect();
  document.addEventListener('shopify:section:load', (event) => collect(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [section, cleanup] of instances) {
      if (section === event.target || event.target.contains(section)) { cleanup(); instances.delete(section); }
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers-tabs"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('appliance-bestsellers')) {

  customElements.define('appliance-bestsellers', class extends HTMLElement {

    connectedCallback() {

      if (this.controller) return;

      const start = () => {

        if (!this.isConnected || this.controller) return;

        this.controller = new AbortController();

        const { signal } = this.controller;

        this.tabs = [...this.querySelectorAll('[data-appliance-tab]')];

        this.panels = [...this.querySelectorAll('[data-appliance-panel]')];

        this.scroller = this.querySelector('[data-appliance-tabs-scroll]');

        if (!this.tabs.length) return;

        if (this.scroller) this.scroller.hidden = false;

        this.tabs.forEach((tab, index) => {

          tab.addEventListener('click', () => this.show(index), { signal });

          tab.addEventListener('keydown', (event) => {

            const rtl = getComputedStyle(this).direction === 'rtl';

            let target = index;

            if (event.key === 'ArrowRight') target += rtl ? -1 : 1;

            else if (event.key === 'ArrowLeft') target += rtl ? 1 : -1;

            else if (event.key === 'Home') target = 0;

            else if (event.key === 'End') target = this.tabs.length - 1;

            else return;

            event.preventDefault();

            target = (target + this.tabs.length) % this.tabs.length;

            this.show(target, true);

          }, { signal });

        });

        this.addEventListener('shopify:block:select', (event) => {

          const index = this.tabs.findIndex((tab) => tab.dataset.blockId === String(event.detail?.blockId || ''));

          if (index >= 0) this.show(index);

        }, { signal });

        const selected = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');

        this.show(selected >= 0 ? selected : 0);

      };

      if (document.readyState === 'loading') {

        this.readyListener = start;

        document.addEventListener('DOMContentLoaded', start, { once: true });

      } else start();

    }

    disconnectedCallback() {

      this.controller?.abort();

      this.controller = null;

      if (this.readyListener) document.removeEventListener('DOMContentLoaded', this.readyListener);

      this.readyListener = null;

    }

    show(index, focus = false) {

      const chosen = this.tabs?.[index];

      if (!chosen) return;

      const target = chosen.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {

        const selected = tab === chosen;

        tab.classList.toggle('is-active', selected);

        tab.setAttribute('aria-selected', String(selected));

        tab.tabIndex = selected ? 0 : -1;

      });

      this.panels.forEach((panel) => {

        const active = panel.id === target;

        panel.hidden = !active;

        panel.classList.toggle('is-active', active);

      });

      if (focus) chosen.focus({ preventScroll: true });

      if (this.scroller) {

        const scrollBox = this.scroller.getBoundingClientRect();

        const tabBox = chosen.getBoundingClientRect();

        let offset = 0;

        if (tabBox.left < scrollBox.left + 6) offset = tabBox.left - scrollBox.left - 6;

        else if (tabBox.right > scrollBox.right - 6) offset = tabBox.right - scrollBox.right + 6;

        if (offset) this.scroller.scrollBy({ left: offset, behavior: 'auto' });

      }

    }

  });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-aidefer-v2"] && !Shopify.designMode) return;
  try {
    



  class StickyHeaderAideferV2 extends HTMLElement {



    constructor() {



      super();



      this.setHeaderHeight = this.setHeaderHeight.bind(this);



    }







    connectedCallback() {



      this.header = this.closest('.section-header');



      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');



      this.headerIsAlwaysSticky =



        this.getAttribute('data-sticky-type') === 'always' ||



        this.getAttribute('data-sticky-type') === 'reduce-logo-size';



      this.headerBounds = {};







      this.setHeaderHeight();







      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);







      if (this.headerIsAlwaysSticky) {



        this.header.classList.add('shopify-section-header-sticky');



      }







      this.currentScrollTop = 0;



      this.preventReveal = false;



      this.predictiveSearches = this.querySelectorAll('predictive-search');







      this.onScrollHandler = this.onScroll.bind(this);



      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);







      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);



      window.addEventListener('scroll', this.onScrollHandler, false);







      this.createObserver();



    }







    setHeaderHeight() {



      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);



    }







    disconnectedCallback() {



      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);



      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);



      window.removeEventListener('scroll', this.onScrollHandler);



    }







    createObserver() {



      let observer = new IntersectionObserver((entries, observer) => {



        this.headerBounds = entries[0].intersectionRect;



        observer.disconnect();



      });







      observer.observe(this.header);



    }







    onScroll() {



      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;







      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;







      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {



        this.header.classList.add('scrolled-past-header');



        if (this.preventHide) return;



        requestAnimationFrame(this.hide.bind(this));



      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {



        this.header.classList.add('scrolled-past-header');



        if (!this.preventReveal) {



          requestAnimationFrame(this.reveal.bind(this));



        } else {



          window.clearTimeout(this.isScrolling);







          this.isScrolling = setTimeout(() => {



            this.preventReveal = false;



          }, 66);







          requestAnimationFrame(this.hide.bind(this));



        }



      } else if (scrollTop <= this.headerBounds.top) {



        this.header.classList.remove('scrolled-past-header');



        requestAnimationFrame(this.reset.bind(this));



      }







      this.currentScrollTop = scrollTop;



    }







    hide() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');



      this.closeMenuDisclosure();



      this.closeSearchModal();



    }







    reveal() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.add('shopify-section-header-sticky', 'animate');



      this.header.classList.remove('shopify-section-header-hidden');



    }







    reset() {



      if (this.headerIsAlwaysSticky) return;



      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');



    }







    closeMenuDisclosure() {



      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');



      this.disclosures.forEach((disclosure) => disclosure.close());



    }







    closeSearchModal() {



      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');



      this.searchModals.forEach((searchModal) => searchModal.close(false));



    }



  }







  document.addEventListener(



    'open',



    (event) => {



      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;







      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));



      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);



    },



    true



  );







  if (!customElements.get('sticky-header-aidefer-v2')) {



    customElements.define('sticky-header-aidefer-v2', StickyHeaderAideferV2);



  }



  const alignAideferMegaMenu = (details) => {
    const content = details.querySelector(':scope > .mega-menu__content');
    if (!content) return;

    content.style.setProperty('--aidefer-mega-menu-shift', '0px');

    requestAnimationFrame(() => {
      const gutter = 16;
      const bounds = content.getBoundingClientRect();
      let shift = 0;

      if (bounds.left < gutter) {
        shift = gutter - bounds.left;
      } else if (bounds.right > window.innerWidth - gutter) {
        shift = window.innerWidth - gutter - bounds.right;
      }

      content.style.setProperty('--aidefer-mega-menu-shift', `${Math.round(shift)}px`);
    });
  };

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('.mega-menu') || !details.open) return;
    alignAideferMegaMenu(details);
  }, true);

  window.addEventListener('resize', () => {
    document.querySelectorAll('.mega-menu[open]').forEach(alignAideferMegaMenu);
  }, { passive: true });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('westmere-logo-marquee-v6')) {
    customElements.define('westmere-logo-marquee-v6', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.events?.abort();
        this.observer?.disconnect();
        this.removeAttribute('data-dragging');
        this.ready = false;
      }

      initialize() {
        if (this.ready || !this.isConnected) return;
        this.track = this.querySelector('.logo-slider__track');
        this.viewport = this.querySelector('.logo-slider__viewport');
        this.pagination = this.querySelector('.logo-slider__pagination');
        if (!this.track || !this.viewport) return;
        this.ready = true;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.autoplay = this.classList.contains('logo-slider--autoplay');
        this.speed = Math.max(1, Number(this.dataset.scrollSpeed) || 28);
        this.update = () => {
          if (this.autoplay) {
            const width = this.track.getBoundingClientRect().width;
            if (width > 0 && width !== this.measuredWidth) {
              this.measuredWidth = width;
              this.track.style.setProperty('--logo-duration', (width / this.speed) + 's');
            }
          } else {
            this.buildPagination();
          }
        };
        this.update();
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.viewport);
        }
        window.addEventListener('resize', this.update, options);
        if (!this.autoplay) return;

        this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);
        this.viewport.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          const animation = this.track.getAnimations()[0];
          if (!animation) return;
          this.drag = {
            id: event.pointerId,
            startX: event.clientX,
            startY: event.clientY,
            time: Number(animation.currentTime) || 0,
            animation
          };
          this.didDrag = false;
          this.setAttribute('data-dragging', '');
        }, options);
        window.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const dx = event.clientX - this.drag.startX;
          const dy = event.clientY - this.drag.startY;
          if (!this.didDrag && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 6) {
            this.endDrag();
            return;
          }
          if (Math.abs(dx) > 6) this.didDrag = true;
          if (!this.didDrag) return;
          if (event.cancelable) event.preventDefault();
          const duration = Number(this.drag.animation.effect.getTiming().duration);
          const time = this.drag.time - dx / this.speed * 1000;
          this.drag.animation.currentTime = ((time % duration) + duration) % duration;
        }, { ...options, passive: false });
        const end = event => {
          if (event.pointerId === this.drag?.id) this.endDrag();
        };
        window.addEventListener('pointerup', end, options);
        window.addEventListener('pointercancel', end, options);
        window.addEventListener('blur', () => this.endDrag(), options);
        this.viewport.addEventListener('click', event => {
          if (!this.didDrag) return;
          event.preventDefault();
          event.stopPropagation();
          this.didDrag = false;
        }, { ...options, capture: true });
      }

      endDrag() {
        this.drag = null;
        this.removeAttribute('data-dragging');
      }

      buildPagination() {
        if (!this.pagination) return;
        const items = Array.from(this.track.children);
        const columns = Math.max(1, Number(window.matchMedia('(max-width: 749px)').matches
          ? this.dataset.mobileColumns : this.dataset.desktopColumns) || 1);
        const pages = Math.ceil(items.length / columns);
        if (this.pageColumns === columns && this.pageCount === pages) return;
        this.pageColumns = columns;
        this.pageCount = pages;
        this.pagination.replaceChildren();
        this.pagination.hidden = pages <= 1;
        if (pages <= 1) return;
        for (let index = 0; index < pages; index++) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'logo-slider__dot' + (index === 0 ? ' is-active' : '');
          button.setAttribute('aria-label', 'Go to logo slide ' + (index + 1));
          button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          button.appendChild(document.createElement('span'));
          button.addEventListener('click', () => {
            const left = items[index * columns].getBoundingClientRect().left
              - items[0].getBoundingClientRect().left;
            this.track.scrollTo({ left, behavior: 'smooth' });
            Array.from(this.pagination.children).forEach((dot, position) => {
              dot.classList.toggle('is-active', position === index);
              dot.setAttribute('aria-current', position === index ? 'true' : 'false');
            });
          });
          this.pagination.appendChild(button);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westmere-pdp-v1"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (window.__westmerePDPV1) { window.__westmerePDPV1.boot(); return; }
  const cleanText = (value) => String(value ?? '').replace(/\u00a0/g, ' ').replace(/\r/g, '').trim();

  const readBlocks = (source) => {
    const blocks = [];
    let buffer = '';
    const flush = () => {
      const text = cleanText(buffer);
      if (text) blocks.push({ type: 'text', text });
      buffer = '';
    };
    const visit = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parts = (node.textContent || '').split(/\n/);
        parts.forEach((part, i) => { if (i) flush(); buffer += part; });
        return;
      }
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      const tag = node.tagName.toLowerCase();
      if (['script', 'style', 'template'].includes(tag)) return;
      if (tag === 'br') { flush(); return; }
      if (/^h[1-6]$/.test(tag)) {
        flush();
        const text = cleanText(node.textContent);
        if (text) blocks.push({ type: 'heading', text });
        return;
      }
      const block = ['div', 'p', 'li', 'ul', 'ol', 'section', 'blockquote'].includes(tag);
      if (block) flush();
      node.childNodes.forEach(visit);
      if (block) flush();
    };
    source.childNodes.forEach(visit);
    flush();
    return blocks;
  };

  const hasComplexMarkup = (source) => Boolean(source.querySelector('table, a, img, video, iframe, details, dl'));
  const stripBullet = (text) => cleanText(text).replace(/^(?:[•▪◦✓]|[-–—]\s)\s*/, '');

  const splitLabelValue = (line) => {
    const text = stripBullet(line);
    const colon = text.indexOf(':');
    if (colon > 0 && colon < 100 && !/https?:\/\//i.test(text.slice(0, colon + 3))) {
      const label = cleanText(text.slice(0, colon));
      const value = cleanText(text.slice(colon + 1));
      if (value) return { label, value };
    }
    const dash = text.match(/^(.{1,80}?)\s+[–—-]\s+(.+)$/);
    if (dash) return { label: cleanText(dash[1]), value: cleanText(dash[2]) };
    return null;
  };

  const renderKeyFeatures = (section) => {
    const source = section.querySelector('[data-key-features-fallback]');
    if (!source || source.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (blocks.some((block) => block.type === 'heading' && !/^key features:?$/i.test(block.text))) return;
    const items = blocks.filter((block) => block.type === 'text').map((block) => stripBullet(block.text)).filter(Boolean);
    if (!items.length) return;
    const makeList = (rows) => {
      const list = document.createElement('ul');
      rows.forEach((item) => {
        const li = document.createElement('li');
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = '✓';
        li.append(icon, document.createTextNode(item));
        list.append(li);
      });
      return list;
    };
    source.replaceChildren(makeList(items));
    source.dataset.enhanced = 'true';
  };

  const renderSpecifications = (section) => {
    const source = section.querySelector('[data-specs-fallback]');
    const target = section.querySelector('[data-specs-content]');
    if (!source || !target || target.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (!blocks.length) return;
    const groups = [];
    let group = { title: 'Product Specifications', entries: [] };
    let parsedRows = 0;
    let ambiguousHeading = false;
    const pushGroup = () => { if (group.entries.length) groups.push(group); };
    blocks.forEach((block) => {
      const text = stripBullet(block.text);
      const explicitHeading = block.type === 'heading' || /^\[.+\]$/.test(text) || /^[^:]{1,80}:$/.test(text);
      if (explicitHeading) {
        if (group.entries.length) pushGroup();
        else if (!/^(?:product )?specifications?$/i.test(group.title)) ambiguousHeading = true;
        group = { title: text.replace(/^\[|\]$/g, '').replace(/:$/, ''), entries: [] };
        return;
      }
      const row = splitLabelValue(text);
      if (row) { group.entries.push(row); parsedRows += 1; }
      else if (text) group.entries.push({ text });
    });
    if (!group.entries.length && !/^(?:product )?specifications?$/i.test(group.title)) ambiguousHeading = true;
    pushGroup();
    if (ambiguousHeading || !parsedRows || !groups.length || groups.some((item) => item.entries.some((entry) => 'text' in entry))) return;
    const fragment = document.createDocumentFragment();
    groups.forEach((item, index) => {
      const details = document.createElement('details');
      details.className = 'westmere-pdp__spec-group';
      details.open = index === 0;
      const summary = document.createElement('summary');
      summary.textContent = item.title;
      const rows = document.createElement('dl');
      rows.className = 'westmere-pdp__spec-rows';
      item.entries.forEach((entry) => {
        if ('text' in entry) {
          const p = document.createElement('p');
          p.className = 'westmere-pdp__spec-note';
          p.textContent = entry.text;
          rows.append(p);
        } else {
          const row = document.createElement('div');
          row.className = 'westmere-pdp__spec-row';
          const label = document.createElement('dt');
          const value = document.createElement('dd');
          label.textContent = entry.label;
          value.textContent = entry.value;
          row.append(label, value);
          rows.append(row);
        }
      });
      details.append(summary, rows);
      fragment.append(details);
    });
    target.replaceChildren(fragment);
    target.dataset.enhanced = 'true';
  };

  const renderIncluded = (section) => {
    const source = section.querySelector('[data-included-fallback]');
    const target = section.querySelector('[data-included-content]');
    if (!source || !target || target.dataset.enhanced === 'true' || hasComplexMarkup(source)) return;
    const blocks = readBlocks(source);
    if (blocks.some((block) => block.type === 'heading')) return;
    const items = blocks.map((block) => stripBullet(block.text)).filter(Boolean);
    if (!items.length) return;
    const fragment = document.createDocumentFragment();
    items.forEach((text) => {
      const card = document.createElement('article');
      card.className = 'westmere-pdp__included-card';
      const icon = document.createElement('div');
      icon.className = 'westmere-pdp__included-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '◇';
      const title = document.createElement('strong');
      title.textContent = text;
      card.append(icon, title);
      fragment.append(card);
    });
    target.replaceChildren(fragment);
    target.dataset.enhanced = 'true';
  };

  const initProductContent = (section) => {
    [renderKeyFeatures, renderSpecifications, renderIncluded].forEach((enhance) => {
      try { enhance(section); }
      catch (error) { console.warn('Westmere Supply: original product content retained.', error); }
    });
  };

  const attachFeatureDisclosure = (section, listen, signal) => {
    const wrap = section.querySelector('[data-key-features-wrap]');
    const source = wrap?.querySelector('[data-key-features-fallback]');
    const button = wrap?.querySelector('[data-features-toggle]');
    if (!wrap || !source || !button || wrap.dataset.collapseFeatures === 'false') return () => {};
    const rows = readBlocks(source).filter((block) => block.type === 'text').map((block) => stripBullet(block.text)).filter(Boolean);
    if (!rows.length) return () => {};
    const preview = document.createElement('div');
    preview.className = 'westmere-pdp__features-preview';
    preview.hidden = true;
    const list = document.createElement('ul');
    rows.slice(0, 3).forEach((row) => {
      const li = document.createElement('li');
      const check = document.createElement('span');
      check.textContent = '✓';
      check.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.className = 'westmere-pdp__feature-preview-text';
      text.textContent = row;
      li.append(check, text);
      list.append(li);
    });
    preview.append(list);
    source.before(preview);
    let expanded = false;
    let needed = false;
    let frame = 0;
    let lastWidth = 0;
    const measure = () => {
      const wasHidden = source.hidden;
      const oldStyle = source.getAttribute('style');
      if (wasHidden) {
        source.style.position = 'absolute';
        source.style.visibility = 'hidden';
        source.style.width = `${wrap.clientWidth}px`;
        source.hidden = false;
      }
      const height = source.scrollHeight;
      if (wasHidden) {
        source.hidden = true;
        if (oldStyle === null) source.removeAttribute('style'); else source.setAttribute('style', oldStyle);
      }
      return height;
    };
    const apply = () => {
      source.hidden = needed && !expanded;
      preview.hidden = !needed || expanded;
      button.hidden = !needed;
      button.setAttribute('aria-expanded', String(expanded || !needed));
      button.textContent = expanded ? button.dataset.lessLabel || 'Show less' : button.dataset.moreLabel || 'Show more';
    };
    const refresh = () => {
      frame = 0;
      if (signal.aborted || !wrap.isConnected) return;
      const limit = parseFloat(getComputedStyle(wrap).getPropertyValue('--ap-features-preview')) || 84;
      needed = rows.length > 3 || measure() > limit + 2;
      if (!needed) expanded = false;
      apply();
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(refresh); };
    listen(button, 'click', () => {
      expanded = !expanded;
      apply();
      if (!expanded && button.getBoundingClientRect().top < 0) button.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
    const observer = 'ResizeObserver' in window ? new ResizeObserver((entries) => {
      const width = entries[0]?.contentRect.width || 0;
      if (Math.abs(width - lastWidth) > 1) { lastWidth = width; schedule(); }
    }) : null;
    observer?.observe(wrap);
    listen(window, 'resize', schedule, { passive: true });
    document.fonts?.ready.then(() => { if (!signal.aborted) schedule(); });
    refresh();
    return () => {
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      preview.remove();
      source.hidden = false;
      button.hidden = true;
    };
  };

  const attachOverviewDisclosure = (section, listen, signal) => {
    const wrap = section.querySelector('[data-overview-copy]');
    const content = wrap?.querySelector('[data-overview-content]');
    const button = wrap?.querySelector('[data-overview-toggle]');
    if (!wrap || !content || !button || wrap.dataset.compactOverview === 'false') return () => {};

    let expanded = false;
    let needed = true;
    let frame = 0;
    let observer = null;

    const apply = () => {
      wrap.classList.toggle('is-collapsed', needed && !expanded);
      button.hidden = !needed;
      button.setAttribute('aria-expanded', String(expanded || !needed));
      button.textContent = expanded
        ? button.dataset.lessLabel || 'Show less'
        : button.dataset.moreLabel || 'Read full description';
    };

    const measure = () => {
      frame = 0;
      if (signal.aborted || !wrap.isConnected) return;

      const limit = parseFloat(getComputedStyle(wrap).getPropertyValue('--ap-overview-preview')) || 340;
      const wasCollapsed = wrap.classList.contains('is-collapsed');
      wrap.classList.remove('is-collapsed');
      const fullHeight = content.scrollHeight;
      if (wasCollapsed && !expanded) wrap.classList.add('is-collapsed');

      needed = fullHeight > limit + 24;
      if (!needed) expanded = false;
      apply();
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };

    listen(button, 'click', () => {
      expanded = !expanded;
      apply();
      if (!expanded) {
        wrap.scrollIntoView({
          block: 'nearest',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    });

    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      observer.observe(content);
    } else {
      listen(window, 'resize', schedule, { passive: true });
    }

    document.fonts?.ready.then(() => {
      if (!signal.aborted) schedule();
    });

    measure();

    return () => {
      observer?.disconnect();
      if (frame) cancelAnimationFrame(frame);
      wrap.classList.remove('is-collapsed');
      button.hidden = true;
    };
  };

  const attachInteractions = (section) => {
    const controller = new AbortController();
    const { signal } = controller;
    const listen = (target, name, callback, options = {}) => target?.addEventListener(name, callback, { ...options, signal });
    const thumbs = [...section.querySelectorAll('[data-media-target]')];
    const panels = [...section.querySelectorAll('[data-media-item]')];
    const panelMap = new Map(panels.map((panel) => [panel.dataset.mediaItem, panel]));
    const status = section.querySelector('[data-gallery-status]');
    let activeId = panels.find((panel) => !panel.hidden)?.dataset.mediaItem;
    let lastZoomTrigger = null;
    let raf = 0;
    const dialog = section.querySelector('[data-zoom-dialog]');
    const zoomContent = section.querySelector('[data-zoom-content]');
    const select = section.querySelector('[data-variant-select]');
    const input = section.querySelector('[data-quantity-input]');
    const minus = section.querySelector('[data-quantity-minus]');
    const plus = section.querySelector('[data-quantity-plus]');
    const add = section.querySelector('[data-add-to-cart]');
    const sticky = section.querySelector('[data-mobile-sticky]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const cleanupFeatures = attachFeatureDisclosure(section, listen, signal);
    const cleanupOverview = attachOverviewDisclosure(section, listen, signal);
    const picker = section.querySelector('[data-option-picker]');
    const nativeVariantField = section.querySelector('[data-native-variant-field]');
    const optionGroups = [...(picker?.querySelectorAll('[data-option-position]') || [])];
    const optionInputs = [...(picker?.querySelectorAll('[data-option-input]') || [])];
    const optionMessage = picker?.querySelector('[data-option-message]');
    let remoteRequest = null;
    let requestNumber = 0;

    const mountMedia = (panel) => {
      const template = panel.querySelector('template[data-deferred-media]');
      if (template) template.replaceWith(template.content.cloneNode(true));
      panel.querySelectorAll('iframe[data-westmere-src]').forEach((frame) => {
        frame.src = frame.dataset.aideferSrc;
        delete frame.dataset.aideferSrc;
      });
    };
    const pauseMedia = (panel) => {
      panel.querySelectorAll('video').forEach((video) => video.pause());
      panel.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
      panel.querySelectorAll('iframe').forEach((frame) => {
        if (frame.hasAttribute('src') && frame.getAttribute('src') !== 'about:blank') {
          frame.dataset.aideferSrc = frame.getAttribute('src');
          frame.src = 'about:blank';
        }
      });
    };
    const showMedia = (id, announce = true) => {
      const key = String(id || '');
      const next = panelMap.get(key);
      if (!next) return false;
      panels.forEach((panel) => {
        const active = panel === next;
        if (!active && !panel.hidden) pauseMedia(panel);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      mountMedia(next);
      thumbs.forEach((thumb) => {
        const active = thumb.dataset.mediaTarget === key;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      activeId = key;
      if (announce && status) status.textContent = `Media ${panels.indexOf(next) + 1} of ${panels.length}`;
      return true;
    };
    listen(section.querySelector('[data-gallery]'), 'click', (event) => {
      const thumb = event.target.closest('[data-media-target]');
      if (thumb) showMedia(thumb.dataset.mediaTarget);
      const trigger = event.target.closest('[data-zoom-open]');
      if (!trigger || !dialog?.showModal || !zoomContent) return;
      event.preventDefault();
      lastZoomTrigger = trigger;
      const image = new Image();
      image.alt = trigger.querySelector('img')?.alt || '';
      image.decoding = 'async';
      image.src = trigger.href;
      zoomContent.replaceChildren(image);
      dialog.showModal();
      dialog.querySelector('[data-zoom-close]')?.focus();
      scheduleSticky();
    });
    listen(section.querySelector('.westmere-pdp__thumbs'), 'keydown', (event) => {
      const current = thumbs.indexOf(event.target.closest('[data-media-target]'));
      if (current < 0) return;
      let next;
      if (['ArrowRight','ArrowDown'].includes(event.key)) next = (current + 1) % thumbs.length;
      else if (['ArrowLeft','ArrowUp'].includes(event.key)) next = (current - 1 + thumbs.length) % thumbs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = thumbs.length - 1;
      else return;
      event.preventDefault();
      thumbs[next].focus({ preventScroll: true });
      thumbs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      showMedia(thumbs[next].dataset.mediaTarget);
    });
    listen(section.querySelector('[data-zoom-close]'), 'click', () => dialog?.close());
    listen(dialog, 'click', (event) => { if (event.target === dialog) dialog.close(); });
    listen(dialog, 'close', () => {
      zoomContent?.replaceChildren();
      if (lastZoomTrigger?.isConnected) lastZoomTrigger.focus({ preventScroll: true });
      scheduleSticky();
    });

    const rules = () => ({
      min: Math.max(1, Number(input?.min) || 1),
      step: Math.max(1, Number(input?.step) || 1),
      max: input?.hasAttribute('max') ? Number(input.max) : Infinity
    });
    const updateQuantityButtons = () => {
      if (!input) return;
      const { min, max, step } = rules();
      const value = Number(input.value);
      if (minus) minus.disabled = !Number.isFinite(value) || value <= min;
      if (plus) plus.disabled = !Number.isFinite(value) || value + step > max;
    };
    const normalizeQuantity = () => {
      if (!input) return;
      const { min, max, step } = rules();
      let value = Number(input.value);
      if (!Number.isFinite(value) || input.value.trim() === '') value = min;
      value = Math.max(min, value);
      value = min + Math.round((value - min) / step) * step;
      if (Number.isFinite(max)) value = Math.min(value, min + Math.floor((max - min) / step) * step);
      input.value = String(Math.max(min, value));
      updateQuantityButtons();
    };
    const changeQuantity = (direction) => {
      if (!input) return;
      normalizeQuantity();
      input.value = String(Number(input.value) + direction * rules().step);
      normalizeQuantity();
      input.dispatchEvent(new Event('change', { bubbles: true }));
    };
    listen(minus, 'click', () => changeQuantity(-1));
    listen(plus, 'click', () => changeQuantity(1));
    listen(input, 'input', updateQuantityButtons);
    listen(input, 'change', normalizeQuantity);

    const records = () => [...(select?.options || [])].filter((option) => option.value).map((option) => ({ option, values: optionGroups.map((group) => option.dataset[`option${group.dataset.optionPosition}`] || '') }));
    const selection = () => optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.value || '');
    const sameValues = (a, b) => a.length === b.length && a.every((value, index) => value === b[index]);
    const allVariantsLoaded = () => Number(select?.dataset.variantCount || 0) <= records().length;
    const setText = (selector, value) => { const node = section.querySelector(selector); if (node) node.textContent = value; };
    const setMessage = (message) => {
      if (optionMessage) { optionMessage.textContent = message; optionMessage.hidden = !message; }
    };
    const syncOptionLabels = () => optionGroups.forEach((group) => {
      const selected = group.querySelector('[data-option-input]:checked');
      const label = group.querySelector('[data-option-current]');
      if (label) label.textContent = selected?.value || '';
    });
    const setURL = (variantId) => {
      const url = new URL(window.location.href);
      url.searchParams.delete('option_values');
      if (variantId) url.searchParams.set('variant', variantId);
      else {
        url.searchParams.delete('variant');
        const ids = optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.dataset.optionId || '');
        if (ids.length && ids.every(Boolean)) url.searchParams.set('option_values', ids.join(','));
      }
      window.history.replaceState(window.history.state, '', url);
    };
    const paintAvailability = () => {
      syncOptionLabels();
      if (!allVariantsLoaded()) return;
      const values = selection();
      const availableRecords = records();
      optionGroups.forEach((group, index) => group.querySelectorAll('[data-option-input]').forEach((radio) => {
        const desired = [...values];
        desired[index] = radio.value;
        const match = availableRecords.find((record) => sameValues(record.values, desired));
        const state = !match ? 'missing' : match.option.dataset.available === 'true' ? 'available' : 'soldout';
        const choice = radio.closest('[data-option-choice]');
        if (choice) {
          choice.dataset.optionState = state;
          choice.title = state === 'available' ? radio.value : `${radio.value} — ${state === 'soldout' ? 'Sold out' : 'Not offered with the other selected options'}`;
        }
        radio.setAttribute('aria-label', choice?.title || radio.value);
      }));
    };
    const blockPurchase = (message, loading = false) => {
      if (select) { select.selectedIndex = -1; select.disabled = true; }
      if (add) add.disabled = true;
      setText('[data-add-label]', loading ? 'Checking options…' : 'Unavailable');
      if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = loading ? 'Checking…' : 'Unavailable'; }
      const accelerated = section.querySelector('[data-accelerated]');
      if (accelerated) accelerated.hidden = true;
      const terms = section.querySelector('.westmere-pdp__payment-terms');
      if (terms) terms.hidden = true;
      setText('[data-current-price]', '—');
      setText('[data-sticky-price]', '—');
      for (const selector of ['[data-compare-price]', '[data-saving]', '[data-sku-wrap]']) {
        const node = section.querySelector(selector); if (node) node.hidden = true;
      }
      setText('[data-stock-status]', loading ? 'Checking availability' : 'Unavailable combination');
      section.querySelector('[data-stock-status]')?.classList.add('is-sold-out');
      setMessage(message);
      setText('[data-variant-status]', message);
      scheduleSticky();
    };
    const updateVariant = (announce = false) => {
      const option = select?.selectedOptions[0];
      if (!option || !option.value) {
        normalizeQuantity();
        if (picker && !picker.hidden) blockPurchase('This combination is not offered. Choose another option.');
        return;
      }
      select.disabled = false;
      const data = option.dataset;
      const available = data.available === 'true';
      setText('[data-current-price]', data.price || '');
      setText('[data-sticky-price]', data.price || '');
      setText('[data-compare-price]', data.compare || '');
      setText('[data-saving]', data.saving || '');
      const compare = section.querySelector('[data-compare-price]');
      const saving = section.querySelector('[data-saving]');
      if (compare) compare.hidden = !data.compare;
      if (saving) saving.hidden = !data.saving;
      const skuWrap = section.querySelector('[data-sku-wrap]');
      if (skuWrap) skuWrap.hidden = !data.sku;
      setText('[data-product-sku]', data.sku ? `SKU: ${data.sku}` : '');
      const stock = section.querySelector('[data-stock-status]');
      if (stock) {
        stock.textContent = data.stockText || (available ? 'Available' : 'Sold Out');
        stock.classList.toggle('is-sold-out', !available);
      }
      if (add) add.disabled = !available;
      setText('[data-add-label]', available ? 'Add to Cart' : 'Sold Out');
      if (stickyAdd) { stickyAdd.disabled = !available; stickyAdd.textContent = available ? 'Add to Cart' : 'Sold Out'; }
      const accelerated = section.querySelector('[data-accelerated]');
      if (accelerated) accelerated.hidden = !available;
      const terms = section.querySelector('.westmere-pdp__payment-terms');
      if (terms) terms.hidden = false;
      if (input) {
        input.min = data.min || '1';
        input.step = data.step || '1';
        if (data.max) input.max = data.max;
        else input.removeAttribute('max');
        normalizeQuantity();
      }
      optionGroups.forEach((group) => group.querySelectorAll('[data-option-input]').forEach((radio) => {
        radio.checked = radio.value === data[`option${group.dataset.optionPosition}`];
      }));
      paintAvailability();
      setMessage(available ? '' : 'This configuration is sold out. Select another color or version.');
      if (data.mediaId) showMedia(data.mediaId, false);
      if (announce) {
        setURL(option.value);
        setText('[data-variant-status]', `${option.textContent.trim()}. ${data.price || ''}. ${stock?.textContent || ''}`);
        section.dispatchEvent(new CustomEvent('westmere:variant-change', { bubbles: true, detail: { variantId: option.value, available } }));
      }
      scheduleSticky();
    };
    const resolveRemote = async (values) => {
      const ids = optionGroups.map((group) => group.querySelector('[data-option-input]:checked')?.dataset.optionId || '');
      if (!ids.length || ids.some((id) => !id)) { blockPurchase('Unable to check this combination. Please refresh the page.'); return; }
      remoteRequest?.abort();
      const request = new AbortController();
      remoteRequest = request;
      const sequence = ++requestNumber;
      const timeout = setTimeout(() => request.abort(), 12000);
      blockPurchase('Checking the selected options…', true);
      setURL('');
      const url = new URL(window.location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('section_id', section.dataset.sectionId);
      url.searchParams.set('option_values', ids.join(','));
      try {
        const response = await fetch(url.toString(), { credentials: 'same-origin', signal: request.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Variant lookup failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (sequence !== requestNumber || signal.aborted || !sameValues(values, selection())) return;
        const incoming = [...doc.querySelectorAll('[data-westmere-pdp]')].find((node) => node.dataset.productId === section.dataset.productId && node.dataset.sectionId === section.dataset.sectionId);
        if (!incoming) throw new Error('Product section missing');
        incoming.querySelectorAll('[data-option-input]').forEach((next) => {
          const radio = optionInputs.find((old) => old.dataset.optionId === next.dataset.optionId);
          if (!radio) return;
          const nextChoice = next.closest('[data-option-choice]');
          if (nextChoice?.dataset.optionState) radio.closest('[data-option-choice]').dataset.optionState = nextChoice.dataset.optionState;
        });
        const incomingOption = incoming.querySelector('[data-variant-select] option[selected]');
        const incomingValues = optionGroups.map((group) => incomingOption?.dataset[`option${group.dataset.optionPosition}`] || '');
        if (!incomingOption?.value || !sameValues(incomingValues, values)) { blockPurchase('This combination is not offered. Choose another option.'); return; }
        [...select.options].filter((option) => option.value === incomingOption.value).forEach((option) => option.remove());
        const option = document.importNode(incomingOption, true);
        select.append(option);
        select.disabled = false;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (error) {
        if (sequence === requestNumber && !signal.aborted) blockPurchase('We could not check these options. Select a different option to retry, or refresh the page.');
      } finally { clearTimeout(timeout); }
    };
    const chooseOptions = (radio) => {
      const targetURL = radio.dataset.productUrl;
      if (targetURL) {
        const target = new URL(targetURL, window.location.origin);
        const current = new URL(section.dataset.productUrl || window.location.pathname, window.location.origin);
        if (target.origin === window.location.origin && target.pathname !== current.pathname) { window.location.assign(target.href); return; }
      }
      const values = selection();
      paintAvailability();
      if (!allVariantsLoaded()) { resolveRemote(values); return; }
      remoteRequest?.abort();
      requestNumber += 1;
      const match = records().find((record) => sameValues(record.values, values));
      if (!match) { blockPurchase('This combination is not offered. Choose another option.'); setURL(''); return; }
      select.disabled = false;
      select.value = match.option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    };
    if (picker && select && optionGroups.length && optionGroups.every((group) => group.querySelector('[data-option-input]'))) {
      picker.hidden = false;
      nativeVariantField.hidden = true;
      listen(picker, 'change', (event) => { if (event.target.matches('[data-option-input]')) chooseOptions(event.target); });
  
    }
    listen(select, 'change', () => updateVariant(true));
    listen(window, 'pageshow', () => { if (!select?.disabled) updateVariant(false); });
    listen(select?.form, 'submit', (event) => {
      if (picker && !picker.hidden && (!select.value || select.disabled || add?.disabled)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setMessage('Please select an available product configuration before adding to cart.');
      }
    }, { capture: true });

    const refreshSticky = () => {
      raf = 0;
      if (!sticky || !add) return;
      const editing = document.activeElement?.matches('input:not([type="hidden"]), textarea, select, [contenteditable="true"]');
      const shouldShow = mobile.matches && !editing && !dialog?.open && add.getBoundingClientRect().bottom <= 0 && section.getBoundingClientRect().bottom > window.innerHeight;
      sticky.hidden = !shouldShow;
      sticky.classList.toggle('is-visible', shouldShow);
    };
    function scheduleSticky() { if (sticky && !raf) raf = requestAnimationFrame(refreshSticky); }
    listen(stickyAdd, 'click', () => {
      normalizeQuantity();
      if (input && !input.checkValidity()) {
        input.scrollIntoView({ block: 'center' });
        input.reportValidity();
        return;
      }
      if (add && !add.disabled) add.click();
    });
    if (sticky) {
      listen(window, 'scroll', scheduleSticky, { passive: true });
      listen(window, 'resize', scheduleSticky, { passive: true });
      listen(window.visualViewport, 'resize', scheduleSticky, { passive: true });
      listen(document, 'focusin', scheduleSticky);
      listen(document, 'focusout', scheduleSticky);
    }
    if (activeId) showMedia(activeId, false);
    updateVariant(false);
    normalizeQuantity();
    scheduleSticky();
    return () => {
      controller.abort();
      requestNumber += 1;
      remoteRequest?.abort();
      cleanupFeatures();
      cleanupOverview();
      if (nativeVariantField) nativeVariantField.hidden = false;
      if (picker) picker.hidden = true;
      if (raf) cancelAnimationFrame(raf);
      panels.forEach(pauseMedia);
      if (dialog?.open) dialog.close();
      zoomContent?.replaceChildren();
      delete section.dataset.westmereInitialized;
    };
  };

  const instances = new Map();
  const init = (section) => {
    if (!section || instances.has(section) || section.dataset.westmereBuild !== '1') return;
    initProductContent(section);
    const cleanup = attachInteractions(section);
    instances.set(section, cleanup);
    section.dataset.westmereInitialized = '1';
  };
  const collect = (root = document) => {
    if (root.matches?.('[data-westmere-pdp]')) init(root);
    root.querySelectorAll?.('[data-westmere-pdp]').forEach(init);
  };
  const lifecycle = { boot: collect };
  window.__westmerePDPV1 = lifecycle;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => collect(), { once: true });
  else collect();
  document.addEventListener('shopify:section:load', (event) => collect(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [section, cleanup] of instances) {
      if (section === event.target || event.target.contains(section)) { cleanup(); instances.delete(section); }
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
